import type { ToasterProps } from "sonner";

/**
 * The application's toaster as its layout mounts it: top centre, below the
 * 2.5rem menu bar, with a close button. Plain data outside the client
 * module, so the server layout and ToastView read the same values.
 */
export const APP_TOASTER_PROPS = {
  position: "top-center",
  offset: { top: "3.25rem" },
  mobileOffset: { top: "3.25rem" },
  closeButton: true,
  className: "!z-(--z-toast)",
} as const satisfies ToasterProps;
